import React, { FC, useMemo } from "react"
import { WelfareMoldTyp } from "~src/service/welfare/welfare"
import styles from "./index.module.less"

interface WelfareColorType {
  color: string
}
type WelfareKakeColorType = Record<WelfareMoldTyp, WelfareColorType>


interface WelfareKakeProps {
  type: WelfareMoldTyp
  title?: string
}
const WelfareKake: FC<WelfareKakeProps> = ({ type, title = '参与记录' }) => {
  const WelfareColor: WelfareKakeColorType = useMemo(() => ({
    "1": {
      color: "#26824D"
    },
    "2": {
      color: "#235BC6"
    },
    "3": {
      color: "#E59101"
    }
  }), [])
  const backgroundKake = useMemo(() => {
    return {
      backgroundColor: `${WelfareColor[type as WelfareMoldTyp]?.color}`,
    }
  }, [WelfareColor, type])
  const backgroundName = useMemo(() => {
    return {
      color: `${WelfareColor[type as WelfareMoldTyp]?.color}`,
    }
  }, [WelfareColor, type])

  return <div className={styles.kake}>
    <div className={styles["kake-size-sm"]} style={backgroundKake}></div>
    <div className={styles["kake-size-md"]} style={backgroundKake}></div>
    <div className={styles["kake-size-name"]} style={backgroundName}>{title}</div>
    <div className={styles["kake-size-md"]} style={backgroundKake}></div>
    <div className={styles["kake-size-sm"]} style={backgroundKake}></div>
  </div>
}

export default WelfareKake
